import styled from 'styled-components';
import { BlockingMessage as RawBlockingMessage } from '../../BlockingMessage';
export const Container = styled.div `
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 1;
    display: ${({ shouldBeHidden }) => (shouldBeHidden ? 'none' : 'flex')};
`;
export const CenteredMobileViewContainer = styled.div `
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    & .PlayPauseButton-Button {
        margin: 0 19%;
    }
    & .SeekRelativeButton-Button {
        margin-left: 0;
    }
    & .SeekRelativeButton-Icon {
        height: 42px;
        width: 32px;
    }
`;
CenteredMobileViewContainer.displayName = 'CenteredMobileViewContainer';
export const BlockingMessage = styled(RawBlockingMessage) `
    margin: 44px 0;
    font-size: 20px;
    letter-spacing: -0.17px;
`;
BlockingMessage.displayName = 'BlockingMessage';
export const buttonStyles = (isLandscape = false) => {
    return {
        button: {
            marginRight: isLandscape ? '45%' : '6%',
            marginLeft: isLandscape ? '45%' : '6%',
        },
        icon: {
            height: 48,
            width: 48,
        },
    };
};
export const middleButtonStyles = Object.assign(Object.assign({}, buttonStyles), { icon: {
        height: 56,
        width: 56,
    } });
//# sourceMappingURL=index.js.map